import { render, staticRenderFns } from "./TableListPage.vue?vue&type=template&id=487c9731&scoped=true"
import script from "./TableListPage.vue?vue&type=script&lang=js"
export * from "./TableListPage.vue?vue&type=script&lang=js"
import style0 from "./TableListPage.vue?vue&type=style&index=0&id=487c9731&prod&lang=scss&scoped=true"
import style1 from "./TableListPage.vue?vue&type=style&index=1&id=487c9731&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c9731",
  null
  
)

export default component.exports